/* ========================================================================
   © 2026 SpeedToLead Framework. All rights reserved.
   ======================================================================== */
import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";

export default function NotFound() {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <SiteHeader />
            <main role="main" className="mx-auto max-w-3xl px-6 py-24 md:px-10">
                <p className="font-mono text-xs uppercase tracking-[0.28em] text-primary">▪ 404</p>
                <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tight">
                    Route not found.
                </h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    The URL you requested isn&apos;t part of the SpeedToLead Framework.
                </p>
                <Link
                    to="/"
                    data-testid="notfound-home"
                    className="mt-8 inline-block bg-primary px-6 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-primary-foreground hover:bg-primary/90"
                >
                    Return to funnel
                </Link>
            </main>
            <SiteFooter />
        </div>
    );
}
